module.exports = __webpack_public_path__ + "assets/img/logo.043062a3.png";